import React, { useMemo,useEffect,useState } from "react";

//import components
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png"
import { subscribeToTokenRefresh } from "../../../helpers/Refreshfile";
import axios from "axios"
import { Card, CardBody, Alert } from "reactstrap";
const baseUrl = process.env.REACT_APP_BASE_URL;
// interface column {
//     header: string,
//     accessorKey: string,
//     enableColumnFilter: boolean,
//     enableSorting: boolean,
// }

interface column {
  header: string;
  accessorKey?: string;
  accessorFn?: (row: any) => string;
  enableColumnFilter: boolean;
  enableSorting: boolean;
  cell?: (info: any) => React.ReactNode;
}



const Abookings = () => {

  const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false })
    };
    const [showloader, setshowloader] = useState(true);

    const columns: column[] = useMemo(
        () => [
            {
                header: '#ID',
                accessorKey: 'id',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Customer Info',
                accessorFn: (row: any) => {
                  const first_name = row?.cust?.user?.first_name || '';
                  const email = row?.cust?.user?.email || '';
                  return `${first_name} ${email}`;
                },
                enableColumnFilter: false,
                enableSorting: true,
                cell: (info: any) => {
                  const row = info.row.original;
                  const first_name = row?.cust?.user?.first_name;
                  const email = row?.cust?.user?.email;
                  const attachment = row?.cust?.user?.profile_pic;
              
                  return (
                    <div className="d-flex align-items-center">
                        <img
                            src={attachment ? `${baseUrl}${attachment}` : defaultUserImg}
                            alt="User"
                            width="50"
                            height="50"
                            className="rounded-circle object-fit-cover"
                            style={{ marginRight: '10px' }}
                            onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = defaultUserImg;
                            }}
                        />
                        <div>
                            <div className="fw-medium">{first_name || "No first name"}</div>
                            <div className="font-size-12">{email || "No email"}</div>
                        </div>
                    </div>
                  );
                }
              },
            {
              header: 'Expert Info',
              accessorFn: (row: any) => {
                const first_name = row?.expert?.user?.first_name || '';
                const email = row?.expert?.user?.email || '';
                return `${first_name} ${email}`;
              },
              enableColumnFilter: false,
              enableSorting: true,
              cell: (info: any) => {
                const row = info.row.original;
                const first_name = row?.expert?.user?.first_name;
                const email = row?.expert?.user?.email;
                const attachment = row?.expert?.user?.profile_pic;
            
                return (
                  <div className="d-flex align-items-center">
                        <img
                            src={attachment ? `${baseUrl}${attachment}` : defaultUserImg}
                            alt="User"
                            width="50"
                            height="50"
                            className="rounded-circle object-fit-cover"
                            style={{ marginRight: '10px' }}
                            onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = defaultUserImg;
                            }}
                        />
                        <div>
                            <div className="fw-medium">{first_name || "No first name"}</div>
                            <div className="font-size-12">{email || "No email"}</div>
                        </div>
                    </div>
                );
              }
            },
            
            {
                header: 'Phone',
                accessorKey: 'expert.user.phone',
                enableColumnFilter: false,
                enableSorting: true,
            },
            // {
            //     header: 'Booking Date',
            //     accessorKey: 'seldate',
            //     enableColumnFilter: false,
            //     enableSorting: true,
            // },
            {
                header: 'Booking Date',
                accessorKey: 'seldate',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {
                    const date = row.original.seldate;
                    const time = row.original.seltimes?.hour; // Safe access in case seltimes is undefined
                    return time ? `${date} / ${time}` : `${date}`;
                  }              
            },
            {
                header: 'Category',
                accessorKey: 'expert.category',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }: any) => {
                    const category = row.original.expert?.category;
                    if (category) {
                      // const subcategories = category.subcats && category.subcats.length > 0
                      //   ? category.subcats.map((subcat: any) => subcat.name).join(", ")  
                      //   : 'No subcategories';
                
                      return (
                        <>
                          {category.name} <br /> {row.original.expert?.subcategory.name}  
                        </>
                      );
                    }
                    return 'No category available';  
                  },
            },
            {
                header: 'Session',
                accessorKey: 'expert.packs',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }: any) => {return `$${row.original?.expert_price} / ${row.original?.exp_session_mins} Mins`},
            },
            {
                header: 'Purpose',
                accessorKey: 'purpose',
                enableColumnFilter: false,
                enableSorting: true,
            },
        ],
        []
    );


    const [bookings, setBookings] = useState<any[]>([]);
    console.log('bookings-----',bookings)
      const fetch_bookings = async () => {
        try {
          setshowloader(true)
          const response = await axios.post(
            `/bookings/admin_bookings`,
            {},
            { withCredentials: true }
          );
          if (response.status === 'SENT') {
            setshowloader(false);
            setBookings(response.bookings);
          }
        } catch (error:any) {
          if (error.response) {
              if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
              }
              else if (error.response.status === 403) {
                console.log('Error stripe payment')
                  setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                  setTimeout(()=>{window.location.href="/logout"}, 2000)
              } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
              }
          } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
          }
          setshowloader(false)
      }
      };
      
      useEffect(() => {
        subscribeToTokenRefresh(() => {
            console.log("🔁 Token refreshed. Re-fetching experts...");
            fetch_bookings();
        }); 
        fetch_bookings();
      }, []);
    


    //meta title
    document.title = "Data Tables | Skote - React Admin & Dashboard Template";

    return (
        <div className="page-content">
            <div className="container-fluid">
              {alertMsgg.open && (
              <Alert
              color={alertMsgg.type === "success" ? "success" : "danger"}
              toggle={handleAlertMsggClose}
              style={{ fontWeight: "bold" }}
              >
              {alertMsgg.content}
              </Alert>
              )}
              <div className="loaderContainer" hidden={!showloader}>
              <div className="spinner">
                <div></div>  
                <div></div>    
                <div></div>    
                <div></div>    
                <div></div>    
                <div></div>    
                <div></div>    
                <div></div>    
                <div></div>    
                <div></div>    
              </div>
            </div>
                <Breadcrumbs title="Tables" breadcrumbItem="Platform Bookings" />
                {/* <p>Booking List</p> */}
                <div className="font-size-13 text-dark">
                  <p>The platform's bookings consist of interactions between experts and customers.</p>
                </div>
                <Card className="rounded-4">
                  <CardBody>
                    <TableContainer
                        columns={columns}
                        data={bookings || []}
                        isGlobalFilter={true}
                        isPagination={true}
                        SearchPlaceholder="Search By Name..."
                        pagination="pagination"
                        paginationWrapper='dataTables_paginate paging_simple_numbers'
                        tableClass="table-bordered dt-responsive table-nowrap w-100 dataTable no-footer dtr-inline"
                    />
                  </CardBody>
                </Card>
            </div>
        </div>
    );
}
export default Abookings;